import { isFunction } from 'lodash';
import T from 'prop-types';
import React from 'react';

import { be, bm } from '@skippay/core/utils/classUtils';

import FormattedValidation from 'components/FormattedValidation';

import './index.sass';

const MODULE_NAME = 'FormField';

export const FormErrorMessage = (props) => {
	const { errorFormat, Component, outsideOfField } = props;

	return (
		<Component className={be(MODULE_NAME, 'errorText', { outsideOfField })}>
			{isFunction(errorFormat) ? (
				errorFormat(props.errorMessage)
			) : (
				<FormattedValidation value={props.errorMessage} />
			)}
		</Component>
	);
};

FormErrorMessage.propTypes = {
	Component: T.oneOfType([T.string, T.func]),
	errorFormat: T.func,
	errorMessage: T.node,
};

FormErrorMessage.defaultProps = {
	Component: 'span',
};

function FormField(props) {
	const {
		isActive,
		isCheckbox,
		isDisabled,
		isEmpty,
		isFilled,
		isReadOnly,
		label,
		noOffsetBottom,
		noSpacing,
		noSpacingBottom,
		noWrapError,
		outsideOfField,
		questionnaire,
		showExclamationWhenInvalid,
		showValidationIcons,
		showErrorImmediately,
	} = props;

	const hasError = showErrorImmediately ? props.hasError : props.hasError && props.isTouched;

	return (
		<div
			className={bm(MODULE_NAME, {
				disabled: isDisabled,
				readOnly: isReadOnly,
				empty: isEmpty,
				active: isActive,
				filled: isFilled,
				hasError,
				noOffsetBottom,
				noSpacing,
				noSpacingBottom,
				isCheckbox,
				noWrapError,
				questionnaire,
				showValidationIcons: showExclamationWhenInvalid || showValidationIcons,
			})}
		>
			<label className={be(MODULE_NAME, 'label')} htmlFor={props.id}>
				<span className={be(MODULE_NAME, 'labelText', label ? label.labelColor : false)}>
					{label}
				</span>

				<div className={be(MODULE_NAME, 'controlWrapper')}>
					<div className={be(MODULE_NAME, 'control')}>{props.children}</div>
				</div>

				{hasError && !props.suppressErrorMessage && (
					<FormErrorMessage
						errorFormat={props.errorFormat}
						errorMessage={props.error}
						outsideOfField={outsideOfField}
					/>
				)}
			</label>
		</div>
	);
}

FormField.propTypes = {
	outsideOfField: T.bool,
	questionnaire: T.bool,
	showExclamationWhenInvalid: T.bool,
	showValidationIcons: T.bool,
	suppressErrorMessage: T.bool,
	showErrorImmediately: T.bool,
};

export default FormField;
